<!--切换背景图-->
<template>
    <div class="demo-bg">
        <div class="demo-bg-list" v-for="(item,index) in imgArr" :key="index">
            <img class="demo-chg-bg" :src="item" key="index" @click="setImg(index)" alt="Background Image">
        </div>
    </div>
</template>

<script>
import Lockr from 'lockr'
import { mapGetters, mapMutations } from "vuex";

export default {
    name: "wallpaper",
    computed: { ...mapGetters(['loginImg']), },
    data() {
        return {
            imgArr: [
                '/htmlStatic/img/bg_img_1_thumb.jpg',
                '/htmlStatic/img/bg_img_2_thumb.jpg',
                '/htmlStatic/img/bg_img_3_thumb.jpg',
                '/htmlStatic/img/bg_img_4_thumb.jpg',
                '/htmlStatic/img/bg_img_5_thumb.jpg',
                '/htmlStatic/img/bg_img_6_thumb.jpg',
            ]
        };
    },
    methods: {
        ...mapMutations(['SET_LOGIN_IMG']),
        // 设置头像
        setImg(i) {
            Lockr.set('loginBg', i)
            this.SET_LOGIN_IMG(i)
        },
        // 获取已设置的背景图
        getImg() {
            let index = Lockr.get('loginBg')
            this.SET_LOGIN_IMG(index)
        },
    },
    created() {
        this.getImg()
    },
}
</script>

<style scoped lang='less'>
.demo-bg {
    display: inline-block;
    text-align: center;
    background-color: #fff;
    padding: 3px;
    .demo-bg-list {
        width: 100px;
        height: 66px;
        display: inline-block;
        padding: 3px;
        img {
            vertical-align: top;
            width: 100%;
            height: 100%;
            object-fit: cover;
            cursor: pointer;
            transition: opacity .5s;
        }
    }
}

@media (max-width: 1198px) {
    .demo-bg {
        position: fixed;
        right: 30px;
        top: 50%;
        transform: translateY(-50%);
        .demo-bg-list {
            display: block;
        }
    }
}

@media (max-width: 768px) {
    .demo-bg {
        display: none;
    }
}
</style>